import { IndividualReportTemplateModel } from '../model/individual-report-template.model';

export const indTemplateBuilderFeatureKey = 'individual-template-builder';

export interface IndTemplateBuilderState {
  template: IndividualReportTemplateModel | null;
  saving: boolean;
}

export const initialIndTemplateBuilderState: IndTemplateBuilderState = {
  template: null,
  saving: false,
};
